import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import groupBy = require('lodash/groupBy');
import keys = require('lodash/keys');
import startCase = require('lodash/startCase');
import { AuthService } from '../../components/security/authorization/auth.service';
import { RolesAware } from '../../domain/authorization/roles-aware.class';
import { UserAware, UserAwareBase } from '../../domain/model/user/user-aware.class';
import { UserImpersonationService } from '../../domain/model/user/user-impersonation.service';
import { VerificationService } from '../../components/verification/service/verification.service';
import { VerificationSummaryModel } from '../../components/verification/model/verification.model';
import { chain } from 'lodash';
import moment = require('moment');



@Component({
    template: require('./verification-summary.component.html'),
    styles: [require('../shared/section/section.component.scss'), require('./verification-summary.component.scss')]
})
@Injectable()
export class VerificationSummaryComponent extends RolesAware(UserAware(UserAwareBase)) implements OnDestroy, OnInit {
    private subscriptions: Subscription;
    public error: Error|undefined;
    public loading: boolean = false;
    public objectKeys = keys;
    public readableProperty = startCase;
    public verificationSummary;
    public verifiedUserName: string | undefined;
    public notesTruncateLimit: number = 50;
    public hideNotes: boolean = false;
    public profileStatus;

    constructor(
        readonly authService: AuthService,
        readonly impersonationService: UserImpersonationService,
        readonly verificationService: VerificationService,
    ) {
        super(authService);
        this.subscriptions = new Subscription();
    }

    ngOnInit(): void {
        this.verifiedUserName = this.impersonationService.impersonatedUserFullName;
        this.loading = true;
        this.subscriptions.add(
            this.verificationService.getSummary()
            .subscribe((verification: VerificationSummaryModel) => {
                this.verificationSummary = groupBy(verification.summary, 'section');
                this.profileStatus = verification.profileStatus;
                this.error = undefined;
                this.loading = false;
            },
            err => {
                this.error = err;
                this.loading = false;
            })
        );
    }

    ngOnDestroy(): void {
        if (this.subscriptions) this.subscriptions.unsubscribe();
    }

    formatDate(date): string {
        return date ? moment(date).format('MM/DD/YYYY') : '';
    }

    formatStatus(status: string): string {
        return chain(status).lowerCase().startCase().value();
    }

    printPage(hideDetails?: boolean) {
        this.hideNotes = !!hideDetails;
        setTimeout(() => window.print(), 200);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/verification/verification-summary.component.ts